// Framework
import { Col, Row } from 'reactstrap';
import { AppContainer } from 'components/style/Containers.style';
import { GoBackButton } from './AccessDenied.style';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import React from 'react';

const AccessDeniedComponent = ({ favicon = null }, { t, router }) => (
  <React.Fragment>
    <Helmet>
      <title>{`${t('Access Denied')} | ${t('Novus Health Dashboard')}`}</title>
      <link
        id="favicon_helmet_link"
        rel="shortcut icon"
        href={favicon}
        data-react-helmet="true"
        type="image/x-icon"
      />
    </Helmet>
    <AppContainer>
      <Row>
        <Col xs={10}>
          <h1 className={'my-5'}>{t('Access Denied')}</h1>
          <p>
            {t(
              'You do not have permission to access this page. For more information, please contact your Site Administrator.'
            )}
          </p>

          <GoBackButton onClick={router.history.goBack}>
            {t('Go back')}
          </GoBackButton>
        </Col>
      </Row>
    </AppContainer>
  </React.Fragment>
);

AccessDeniedComponent.contextTypes = {
  t: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired
};

export default AccessDeniedComponent;



// WEBPACK FOOTER //
// ./src/components/pages/AccessDenied/AccessDeniedComponent.js